import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { CustomerGroup } from './customer-group.interface';

export class CustomerGroupService {
   async getCustomerGroups(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<CustomerGroup>>(`/customer-groups`, { params: { ...query } });
      return response.data;
   }

   async getCustomerGroup(customerGroupId: number, params?: LocationQuery) {
      const response = await http.get<ApiResource<CustomerGroup>>(`/customer-groups/${customerGroupId}`, { params });
      return response.data.data;
   }

   async postCustomerGroup(customerGroup: CustomerGroup) {
      const response = await http.post<ApiResource<CustomerGroup>>(`/customer-groups`, customerGroup, { params: { append: 'scopes' } });
      return response.data.data;
   }

   async putCustomerGroup(customerGroupId: number, customerGroup: CustomerGroup, params?: LocationQuery) {
      const response = await http.put<ApiResource<CustomerGroup>>(`/customer-groups/${customerGroupId}`, customerGroup, {
         params: { ...params, append: 'scopes' },
      });
      return response.data.data;
   }

   async deleteCustomerGroup(customerGroupId: number) {
      const response = await http.delete(`/customer-groups/${customerGroupId}`);
      return response.data;
   }
}
